// //Without thousand sepeartors and total will be corrected

// import React, { useState } from "react";
// import flag from "../images/BG.jpg";
// import axios from "axios";
// import { useAuth, useInvoice } from '../AuthContext';
// import { useNavigate } from 'react-router-dom';
// import { Trash, Plus } from "lucide-react";
// // import formbg from '../images/Formbg.jpg'
// import formbg from '../images/Formbg.png'

// const InvoicePage = () => {
//   const navigate = useNavigate();
//   const [showAdvance, setShowAdvance] = useState(false);
//   const [showTable, setShowTable] = useState(false);
//   const [invoices, setInvoices] = useState([]);
//   const [clientName, setClientName] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [invoiceItems, setInvoiceItems] = useState([]);
//   const [isAdvancePayment, setIsAdvancePayment] = useState(false);
//   const [tax, setTax] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [paidAmount, setPaidAmount] = useState(0);
//   const [advanceAmount, setAdvanceAmount] = useState(0);
//   const [remainingBalance, setRemainingBalance] = useState(0);
//   const [invoiceNumber, setInvoiceNumber] = useState("");
//   const [baseInvoiceNumber, setBaseInvoiceNumber] = useState("");
//   const [clientId, setClientId] = useState(0);
//   const { user } = useAuth();
//   const [totalAmount, setTotalAmount] = useState("");
//   const [installments, setInstallments] = useState([]);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [submittedData, setSubmittedData] = useState(null);

//   const now = new Date();
//   const time = now.toLocaleTimeString();
//   const date = now.toLocaleDateString();

//   const formatDate = (dateString) => {
//     const now = new Date();
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) {
//       return "Invalid date";
//     }
//     // return date.toISOString().split("T")[0];
//     return date.toLocaleDateString("en-CA");

//   };
//   const fetchPendingInvoices = async () => {
//     setLoading(true);
//     try {
//       // const response = await axios.get("http://localhost:5045/api/Invoice/PendingByCustomer", {
//       //   params: { clientName, mobileNumber },
//       // });
//       const response = await axios.get("https://invoice.dockyardsoftware.com/api/Invoice/PendingByCustomer", {
//         params: { clientName, mobileNumber },
//       });

//       console.log("Fetched Data:", response.data);
//       const invoicesData = response.data?.$values || [];

//       const updatedInvoices = invoicesData.map((invoice) => ({
//         ...invoice,
//         total: invoice.remainingBalance || invoice.total,
//       }));

//       setInvoices(updatedInvoices);
//       setError(null);

//       const newTotal = updatedInvoices.reduce((acc, invoice) => acc + (invoice.total || 0), 0);
//       setTotalAmount(newTotal);

//     } catch (error) {
//       console.error("Error fetching invoices:", error.response);
//       setError(error.response?.data?.message || "Error fetching pending invoices");
//       setInvoices([]);
//       setTotalAmount(0);
//     }
//     setLoading(false);
//   };

//   const handleSearchClick = () => {
//     setShowTable(true);
//     fetchPendingInvoices();
//   };

//   const fetchInvoiceItems = async (invoiceNumber) => {
//     try {
//       const response = await axios.get(`https://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`);
//       const invoiceData = response.data;
//       console.log("API Response Data:", response.data);

//       if (invoiceData) {
//         const totalAmount = invoiceData.items?.$values?.reduce(
//           (total, item) => total + item.unitPrice * item.quantity,
//           0
//         ) || 0;

//         const remainingBalance = Math.max(
//           totalAmount - (invoiceData.paidAmount + (invoiceData.advanceAmount || 0)),
//           0
//         );

//         setInvoiceNumber(invoiceData.invoiceNumber);
//         setBaseInvoiceNumber(invoiceData.baseInvoiceNumber);
//         setClientId(invoiceData.clientId);
//         setClientName(invoiceData.clientName);
//         setMobileNumber(invoiceData.mobileNumber);
//         setTax(invoiceData.tax);
//         setDiscount(invoiceData.discount);
//         setPaidAmount(invoiceData.paidAmount);
//         setAdvanceAmount(invoiceData.advanceAmount);
//         setInvoiceItems(invoiceData.items?.$values || []);
//         setRemainingBalance(invoiceData.remainingBalance);
//         setRemainingBalance(invoiceData.remainingBalance);

//         setInvoices(invoiceData.map(inv => ({
//           ...inv,
//           remainingBalance: inv.remainingBalance
//         })));

//       }
//     } catch (error) {
//       console.error("Error fetching invoice details:", error);
//     }
//   };

//   // const handleItemChange = (index, field, value) => {
//   //   const updatedItems = [...invoiceItems];
//   //   updatedItems[index] = {
//   //     ...updatedItems[index],
//   //     [field]: value,
//   //   };
//   //   setInvoiceItems(updatedItems);  // Update items li
//   // };

//   const handleItemChange = (index, field, value) => {
//     if (field === "quantity") {
//       if (value === "" || /^\d*\.?\d*$/.test(value)) {
//         const updatedItems = [...invoiceItems];
//         updatedItems[index] = {
//           ...updatedItems[index],
//           [field]: value,
//         };
//         setInvoiceItems(updatedItems);
//       }
//     } else {
//       const updatedItems = [...invoiceItems];
//       updatedItems[index] = {
//         ...updatedItems[index],
//         [field]: value,
//       };
//       setInvoiceItems(updatedItems);
//     }
//   };

//   const handleAddItem = () => {
//     setInvoiceItems([
//       ...invoiceItems,
//       { productName: "", quantity: "", unitPrice: "" },
//     ]);
//   };

//   const handleRemoveItem = (index) => {
//     setInvoiceItems((prevItems) => prevItems.filter((_, i) => i !== index));
//   };

//   const handleClose = () => {
//     setShowSuccessPopup(false);
//     setTimeout(() => window.location.reload(), 300);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     if (isAdvancePayment && advanceAmount <= 0) {
//       alert("Advance amount must be filled for advance payment.");
//       setLoading(false);
//       return;
//     }

//     if (!isAdvancePayment && paidAmount <= 0) {
//       alert("Paid amount must be filled if it's not an advance payment.");
//       setLoading(false);
//       return;
//     }

//     const fullPaymentRequired = remainingBalance > 0 && paidAmount !== remainingBalance;

//     if (fullPaymentRequired) {
//       alert("The full balance must be paid to settle the invoice.");
//       setLoading(false);
//       return;
//     }

//     let finalInvoiceNumber = invoiceNumber;
//     let finalBaseInvoiceNumber = baseInvoiceNumber;
//     let finalBaseInvoiceNumberId = 0;
//     let finalAdvanceAmount = isAdvancePayment ? advanceAmount : 0;

//     const existingInvoice = invoices.find(inv => inv.invoiceNumber === invoiceNumber && inv.remainingBalance > 0);

//     if (existingInvoice) {

//       finalInvoiceNumber = existingInvoice.invoiceNumber;
//       finalBaseInvoiceNumber = existingInvoice.baseInvoiceNumber;
//       finalBaseInvoiceNumberId = existingInvoice.baseInvoiceNumberId;
//       finalAdvanceAmount = existingInvoice.advanceAmount;
//     } else if (!invoiceNumber) {

//       finalInvoiceNumber = `INV_${Date.now()}`;
//     }

//     const totalAmount = invoiceItems.reduce((total, item) => total + (item.unitPrice * item.quantity), 0);

//     const totalWithTax = totalAmount + totalAmount * (tax / 100);
//     const totalWithTaxAndDiscount = totalWithTax - totalWithTax * (discount / 100);

//     const newRemainingBalance = totalWithTaxAndDiscount - (paidAmount + finalAdvanceAmount);

//     if (existingInvoice) {
//       console.log("Unsettled invoice found. Reusing the existing invoice details:", existingInvoice);
//     } else {
//       console.log("No unsettled invoice found. Creating a new invoice:", finalInvoiceNumber);
//     }

//     const invoiceData = {
//       invoiceNumber: finalInvoiceNumber,
//       baseInvoiceNumber: finalBaseInvoiceNumber,
//       baseInvoiceNumberId: finalBaseInvoiceNumberId,
//       userID: user.userID,
//       companyID: user.companyID,
//       total: totalAmount,
//       date: new Date().toISOString(),
//       clientId: clientId,
//       clientName: clientName,
//       mobileNumber: mobileNumber,
//       tax: tax,
//       discount: discount,
//       paidAmount: paidAmount,
//       advanceAmount: finalAdvanceAmount,
//       remainingBalance: newRemainingBalance,
//       pendingStatus: newRemainingBalance > 0 ? "Pending" : "Completed",
//       items: invoiceItems.map((item) => ({
//         invoiceNumber: finalInvoiceNumber,
//         invoiceNumberId: 0,
//         productName: item.productName,
//         unitPrice: item.unitPrice,
//         quantity: item.quantity,
//       })),
//     };

//     console.log("Sending Invoice Data:", invoiceData);

//     try {
//       // const response = await axios.post("http://localhost:5045/api/Invoice", invoiceData);
//       const response = await axios.post("https://invoice.dockyardsoftware.com/api/Invoice", invoiceData);
//       console.log("Invoice submitted successfully", response.data);
//       alert("Invoice submitted successfully");

//       setSubmittedData(invoiceData);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error submitting invoice", error.response);
//       console.log("Invoice Data before sending:", invoiceData);

//       alert("Failed to submit invoice");
//     }

//     setLoading(false);
//     return invoiceData;
//   };

//   // Function to handle Print (submit the data and navigate)
//   // const handlePrint = async (e) => {
//   //   e.preventDefault();
//   //   const invoiceData = await handleSubmit(e); // First, submit the data and get the invoiceData

//   //   // Check if invoiceData is undefined or missing invoiceNumber
//   //   if (!invoiceData || !invoiceData.invoiceNumber) {
//   //     alert("Invoice number is missing! Please check the invoice data.");
//   //     return; // Prevent further action if invoice data is not valid
//   //   }

//   //   // Then navigate to the viewPort page with the invoice data
//   //   navigate(`/viewPort/${invoiceData.invoiceNumber}`, { state: { invoiceData } });
//   // };

//   const handlePrint = (e) => {
//     e.preventDefault();

//     if (!submittedData || !submittedData.invoiceNumber) {
//       alert("Invoice not submitted yet or missing invoice number.");
//       return;
//     }

//     navigate(`/viewPort/${submittedData.invoiceNumber}`, { state: { invoiceData: submittedData } });
//   };

//   const calculateTotal = () => {
//     if (invoiceItems?.length > 0) {

//       const totalAmount = invoiceItems.reduce(
//         (total, item) => total + (item.unitPrice * item.quantity),
//         0
//       );

//       const totalWithTax = totalAmount + totalAmount * (tax / 100);
//       const totalWithTaxAndDiscount = totalWithTax - totalWithTax * (discount / 100);
//       return totalWithTaxAndDiscount;
//     } else if (invoices?.length > 0) {

//       return invoices.reduce((acc, invoice) => acc + (invoice.total || 0), 0);
//     }

//     return 0;
//   };

//   // const handlePaidAmountChange = (e) => {
//   //   let value = e.target.value;

//   //   // Remove leading zeros
//   //   if (value.length > 1 && value.startsWith("0")) {
//   //     value = value.replace(/^0+/, "");
//   //   }

//   //   const newPaidAmount = parseFloat(value) || 0; // Ensure numeric input
//   //   setPaidAmount(newPaidAmount);

//   //   let newRemainingBalance;
//   //   if (newPaidAmount === 0) {
//   //     newRemainingBalance = Math.max(advanceAmount - totalAmount, 0);
//   //   } else {
//   //     newRemainingBalance = Math.max(remainingBalance - newPaidAmount, 0);
//   //   }

//   //   setRemainingBalance(newRemainingBalance);
//   // };

//   const handlePaidAmountChange = (e) => {
//     let value = e.target.value;

//     if (value === '.') value = '0.';
//     if (value.indexOf('.') === value.length - 1) return;

//     const newPaidAmount = parseFloat(value) || 0;
//     setPaidAmount(value === '' ? '' : newPaidAmount);
//   };

//   return (
//     // <div className="flex justify-center items-center h-screen bg-gray-100 px-4 overflow-hidden">
//     <div
//       className="flex justify-center items-start px-4 py-4 sm:py-1 overflow-y-auto min-h-screen"
//       style={{
//         backgroundImage: `url(${formbg})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//         // backgroundAttachment: 'fixed',
//         opacity: 0.9
//       }}
//     >
//       {/* <div className="w-full max-w-5xl bg-white  shadow-lg rounded-2xl p-6 flex flex-col h-full mt-10"> */}
//       <div className="w-full max-w-5xl bg-white/80 shadow-lg rounded-2xl p-4 sm:p-6 flex flex-col my-2 sm:my-7">
//         <div
//           className="relative flex justify-center items-center rounded-xl p-6"
//           style={{
//             backgroundImage: `url(${flag})`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//             height: "120px",
//           }}
//         >
//           <div className="bg-white w-[80%] max-w-lg p-4 rounded-xl shadow-md text-center">
//             <h2 className="text-m font-bold text-[#24419A]">Hi, {user ? user.username : "Guest"}!!</h2>
//             <p className="text-xs font-bold text-gray-400">Current Time: {time}</p>
//             <p className="text-xs font-bold text-gray-400">Current Date: {formatDate(date)}</p>
//           </div>
//         </div>
//         <div className="mt-4 grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] gap-4">

//           <div className="w-full">
//             <label className="block font-bold text-sm text-[#3C6BFF]">Client Name</label>
//             <input
//               type="text"
//               value={clientName}
//               onChange={(e) => setClientName(e.target.value)}
//               placeholder="Enter Customer Name..."
//               className="w-full border-2 border-blue-500 text-sm h-10 rounded-lg p-2 mt-1"
//             />
//           </div>
//           <div className="w-full">
//             <label className="block font-bold text-sm text-[#3C6BFF]">Client Number</label>
//             <input
//               type="number"
//               value={mobileNumber}
//               onChange={(e) => setMobileNumber(e.target.value)}
//               placeholder="Enter Customer Number..."
//               className="w-full border-2 border-blue-500 text-sm h-10 rounded-lg p-2 mt-1"
//             />
//           </div>
//           <div className="flex items-end">
//             <button
//               onClick={handleSearchClick}
//               className="bg-blue-600 text-white px-4 py-2 h-10 rounded-lg hover:bg-blue-700 transition w-auto"
//             >
//               {loading ? "Searching..." : "Search"}
//             </button>
//           </div>
//         </div>

//         {showTable && (
//           <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50">
//             <div className="bg-white p-6 rounded-lg shadow-lg w-4/5 max-w-6xl"> {/* Increase width of the popup */}
//               <div className="flex justify-between">
//                 <h3 className="text-xl font-bold">Invoices</h3>
//                 <button onClick={() => setShowTable(false)} className="text-red-500 font-bold">X</button>
//               </div>

//               <div className="overflow-x-auto mt-4">
//                 <table className="w-full text-sm text-left text-gray-500 border table-auto">
//                   <thead className="text-xs text-gray-700 uppercase bg-gray-200">
//                     <tr>
//                       <th className="px-4 py-3">Invoice Number</th>
//                       <th className="px-4 py-3">Base Invoice Number</th>
//                       <th className="px-4 py-3">Client Name</th>
//                       <th className="px-4 py-3">Total</th>
//                       <th className="px-4 py-3">Date</th>
//                       <th className="px-4 py-3">Paid</th>
//                       <th className="px-4 py-3">Advance</th>
//                       <th className="px-4 py-3">Remaining Balance</th>
//                       <th className="px-4 py-3">Pending</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {loading ? (
//                       <tr>
//                         <td colSpan="9" className="text-center py-3 text-gray-500">
//                           Loading invoices...
//                         </td>
//                       </tr>
//                     ) : invoices.length > 0 ? (
//                       invoices.map((invoice) => (
//                         <tr key={invoice.invoiceNumber} className="border">
//                           <td className="px-4 py-2">{invoice.invoiceNumber}</td>
//                           <td className="px-4 py-2">{invoice.baseInvoiceNumber}</td>
//                           <td className="px-4 py-2">{invoice.clientName}</td>
//                           <td className="px-4 py-2">{invoice.total}</td>
//                           <td className="px-4 py-2">{invoice.date}</td>
//                           <td className="px-4 py-2">{invoice.paidAmount}</td>
//                           <td className="px-4 py-2">{invoice.advanceAmount}</td>
//                           <td className="px-4 py-2">{invoice.remainingBalance}</td>
//                           <td className="px-4 py-2">
//                             {invoice.pendingStatus === "Pending" ? (
//                               <a
//                                 href="#"
//                                 className="text-blue-500"
//                                 onClick={() => {
//                                   console.log("Clicked Invoice Number:", invoice.invoiceNumber);
//                                   fetchInvoiceItems(invoice.invoiceNumber);
//                                   console.log("Fetching data for invoice:", invoice.invoiceNumber);
//                                   setShowTable(false);
//                                 }}
//                               >
//                                 Pending
//                               </a>
//                             ) : (
//                               "Completed"
//                             )}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="9" className="text-center py-3 text-gray-500">
//                           No invoices found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="flex-grow overflow-auto mt-4 pb-4">
//           <h3 className="text-xl font-semibold">Invoice Items</h3>
//           <table className="w-full text-sm text-left text-black border-2 border-white mt-2">
//             <thead className="text-xs text-white uppercase bg-blue-600">
//               <tr>
//                 <th className="px-4 py-2">Product Name</th>
//                 <th className="px-4 py-2">Qty</th>
//                 <th className="px-4 py-2">Price</th>
//                 <th className="px-4 py-2">Amount</th>
//                 <th className="px-4 py-2 text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {invoiceItems.length > 0 ? (
//                 invoiceItems.map((item, index) => (
//                   <tr key={index} className="border-b-2 border-white">
//                     <td className="px-4 py-2">
//                       <input
//                         value={item.productName}
//                         onChange={(e) => handleItemChange(index, "productName", e.target.value)}
//                         type="text"
//                         className="border p-1 rounded w-full"
//                         placeholder="Product"
//                       />
//                     </td>
//                     <td className="px-4 py-2">
//                       <input
//                         value={item.quantity}
//                         // onChange={(e) => handleItemChange(index, "quantity", e.target.value)}
//                         onChange={(e) => {
//                           let value = e.target.value;
//                           if (value === '.') value = '0.';
//                           handleItemChange(index, "quantity", value);
//                         }}
//                         type="number"
//                         className="border p-1 rounded w-full"
//                         placeholder="Qty"
//                       />
//                     </td>
//                     <td className="px-4 py-2">
//                       <input
//                         value={item.unitPrice}
//                         onChange={(e) => handleItemChange(index, "unitPrice", e.target.value)}
//                         type="number"
//                         className="border p-1 rounded w-full"
//                         placeholder="Price"
//                       />
//                     </td>
//                     <td className="px-4 py-2">
//                       {item.quantity && item.unitPrice ? item.quantity * item.unitPrice : 0}
//                     </td>
//                     <td className="px-4 py-2 text-center flex items-center justify-center gap-3">
//                       <button onClick={() => handleRemoveItem(index)} className="text-red-500 hover:text-red-700">
//                         <Trash size={20} />
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" className="text-center py-3 text-gray-500">
//                     No items added yet.
//                   </td>
//                 </tr>
//               )}

//               <tr className="border">
//                 <td colSpan="5" className="text-center py-3">
//                   <button onClick={handleAddItem} className="text-blue-500 hover:text-blue-700 flex items-center justify-center gap-2">
//                     <Plus size={20} />
//                     Add Item
//                   </button>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         <div className="w-full mt-2 p-4 border rounded bg-white/50 text-sm h-[250px] overflow-y-auto">
//           <div className="flex items-center space-x-2">
//             <input

//               type="checkbox"
//               checked={isAdvancePayment}
//               onChange={(e) => setIsAdvancePayment(e.target.checked)}
//             />

//             <label className="text-sm font-bold text-gray-700">Advance Payment</label>
//           </div>

//           <div className="flex space-x-2 mb-2">
//             <div className="w-1/2">
//               <label>Tax (%)</label>
//               <input
//                 type="number"
//                 value={tax}
//                 onChange={(e) => setTax(parseFloat(e.target.value))}
//                 className="border p-1 rounded w-full"
//                 placeholder="0"
//               />
//             </div>
//             <div className="w-1/2">
//               <label>Discount (%)</label>
//               <input
//                 type="number"
//                 value={discount}
//                 onChange={(e) => setDiscount(parseFloat(e.target.value))}
//                 className="border p-1 rounded w-full"
//                 placeholder="0"
//               />
//             </div>
//           </div>

//           <div className="w-1/2">
//             <label>Paid Amount:</label>
//             <input

//               type="number"
//               value={paidAmount === 0 ? '' : paidAmount}
//               onChange={handlePaidAmountChange}
//               onFocus={(e) => e.target.value === '0' && setPaidAmount('')}
//               onBlur={(e) => {
//                 const value = parseFloat(e.target.value) || 0;
//                 setPaidAmount(value);
//               }}
//               placeholder="Enter Paid Amount..."
//               className="border p-1 rounded w-full"
//             />

//           </div>

//           {isAdvancePayment && (
//             <div className="w-1/2">
//               <label >Advance Amount</label>
//               <input
//                 type="number"
//                 value={advanceAmount}
//                 onChange={(e) => setAdvanceAmount(e.target.value)}
//                 placeholder="Enter Advance Amount" className="border p-1 rounded w-full"
//               />
//             </div>
//           )}

//           <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
//             <div className="w-full">
//               <label className="block font-bold text-sm text-[#3C6BFF]">Total</label>
//               <input
//                 type="number"
//                 value={totalAmount || calculateTotal()}
//                 readOnly
//                 className="w-full border-2 border-blue-500 text-sm h-10 rounded-lg p-2 mt-1 bg-gray-200"
//               />

//             </div>
//             <div>

//               <button
//                 className="bg-blue-500 text-white px-3 py-1 rounded mt-7"
//                 onClick={handleSubmit}
//               >
//                 Submit
//               </button>

//             </div>

//             <div>

//             </div>

//             {showSuccessPopup && (
//               <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//                 <div className="bg-white p-6 rounded-2xl shadow-xl max-w-md w-full">
//                   <div className="flex flex-col items-center">
//                     <svg
//                       className="w-12 h-12 text-green-500"
//                       xmlns="http://www.w3.org/2000/svg"
//                       viewBox="0 0 24 24"
//                       fill="currentColor"
//                     >
//                       <path
//                         fillRule="evenodd"
//                         d="M2.25 12a9.75 9.75 0 1117.72 6.28l2.26 2.26a.75.75 0 11-1.06 1.06l-2.26-2.26A9.75 9.75 0 112.25 12zm14.78-2.97a.75.75 0 00-1.06-1.06l-4.97 4.97-2.47-2.47a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l5.5-5.5z"
//                         clipRule="evenodd"
//                       />
//                     </svg>
//                     <h2 className="text-lg font-semibold text-green-600 mt-3">Invoice Submitted</h2>
//                     <p className="text-gray-600 text-center mt-1">Invoice <span className="font-medium text-gray-900">{submittedData.invoiceNumber}</span> has been successfully processed.</p>
//                   </div>

//                   <div className="mt-4 bg-gray-100 p-4 rounded-lg shadow-inner">
//                     <h3 className="text-gray-700 font-semibold text-sm">Invoice Details</h3>
//                     <div className="mt-2 text-sm text-gray-600 space-y-1">
//                       <p><span className="font-medium">Client:</span> {submittedData.clientName}</p>
//                       <p><span className="font-medium">Mobile:</span> {submittedData.mobileNumber}</p>
//                       <p><span className="font-medium">Date:</span> {new Date(submittedData.date).toLocaleDateString()}</p>
//                       <p><span className="font-medium">Total:</span> Rs.{submittedData.total}</p>
//                       <p><span className="font-medium">Paid:</span> Rs.{submittedData.paidAmount}</p>
//                       <p><span className="font-medium">Remaining Balance:</span> Rs.{submittedData.remainingBalance}</p>
//                       <p><span className="font-medium">Status:</span> <span className={`font-medium px-2 py-1 rounded ${submittedData.pendingStatus === "Pending" ? "bg-yellow-100 text-yellow-800" : "bg-green-100 text-green-800"}`}>{submittedData.pendingStatus}</span></p>
//                     </div>
//                   </div>

//                   <div className="mt-4">
//                     <h3 className="text-gray-700 font-semibold text-sm">Items Purchased</h3>
//                     <div className="mt-2 bg-gray-50 p-3 rounded-lg shadow-inner">
//                       <table className="w-full text-sm text-gray-700">
//                         <thead>
//                           <tr className="border-b">
//                             <th className="text-left p-1">Product</th>
//                             <th className="text-right p-1">Unit Price</th>
//                             <th className="text-right p-1">Qty</th>
//                             <th className="text-right p-1">Total</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {submittedData.items.map((item, index) => (
//                             <tr key={index} className="border-b">
//                               <td className="p-1">{item.productName}</td>
//                               <td className="text-right p-1">Rs.{item.unitPrice}</td>
//                               <td className="text-right p-1">{item.quantity}</td>
//                               <td className="text-right p-1">Rs.{item.unitPrice * item.quantity}</td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>

//                   <button
//                     onClick={handleClose}
//                     className="mt-4 w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
//                   >
//                     Close
//                   </button>

//                   <button
//                     className="mt-4 w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
//                     onClick={handlePrint}
//                   >
//                     Print
//                   </button>
//                 </div>
//               </div>

//             )}

//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default InvoicePage;

//Added thousand seperators

import React, { useState } from "react";
import flag from "../images/BG.jpg";
import axios from "axios";
import { useAuth, useInvoice } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import { Trash, Plus } from "lucide-react";
import formbg from "../images/Formbg.png";

const InvoicePage = () => {
  const navigate = useNavigate();
  const [showTable, setShowTable] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [clientName, setClientName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [isAdvancePayment, setIsAdvancePayment] = useState(false);
  const [tax, setTax] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [remainingBalance, setRemainingBalance] = useState(0);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [baseInvoiceNumber, setBaseInvoiceNumber] = useState("");
  const [clientId, setClientId] = useState(0);
  const { user } = useAuth();
  const [totalAmount, setTotalAmount] = useState(0);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);
  const [isPendingInvoice, setIsPendingInvoice] = useState(false);
  const [errors, setErrors] = useState({
    mobileNumber: "",
    clientName: "",
  });
  const validateMobileNumber = (number) => {
    if (!number) return "Mobile number is required";
    if (!/^\d+$/.test(number)) return "Only numbers are allowed";
    if (number.length < 10) return "Mobile number must be at least 10 digits";
    return "";
  };

  const validateClientName = (name) => {
    if (!name) return "Customer name is required";
    if (!/^[A-Za-z\s]+$/.test(name)) return "Only letters are allowed";
    return "";
  }


  const now = new Date();
  const time = now.toLocaleTimeString();
  const date = now.toLocaleDateString();

  const formatNumber = (num) => {
    if (num === null || num === undefined || num === "") return "";
    const numStr = num.toString().replace(/,/g, "");
    if (numStr.includes(".")) {
      const parts = numStr.split(".");
      return `${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${parts[1]}`;
    }
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // const parseFormattedNumber = (formattedNum) => {
  //   if (formattedNum === '') return 0;
  //   return parseFloat(formattedNum.replace(/,/g, '')) || 0;
  // };
  const parseFormattedNumber = (formattedNum) => {
    if (!formattedNum) return 0;
    if (typeof formattedNum === "number") return formattedNum;
    return parseFloat(formattedNum.toString().replace(/,/g, "")) || 0;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid date";
    }
    return date.toLocaleDateString("en-CA");
  };

  // const fetchPendingInvoices = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(
  //       // "https://invoice.dockyardsoftware.com/api/Invoice/PendingByCustomer",
  //       "http://localhost:5045/api/Invoice/PendingByCustomer",
  //       {
  //         params: { clientName, mobileNumber },
  //       }
  //     );

  //     const invoicesData = response.data?.$values || [];
  //     const updatedInvoices = invoicesData.map((invoice) => ({
  //       ...invoice,
  //       total: invoice.remainingBalance || invoice.total,
  //     }));

  //     setInvoices(updatedInvoices);
  //     setError(null);
  //   } catch (error) {
  //     console.error("Error fetching invoices:", error.response);
  //     setError(
  //       error.response?.data?.message || "Error fetching pending invoices"
  //     );
  //     setInvoices([]);
  //   }
  //   setLoading(false);
  // };

  const fetchPendingInvoices = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://invoice.dockyardsoftware.com/api/Invoice/PendingByCustomer",
        // "http://localhost:5045/api/Invoice/PendingByCustomer",
        {
          params: { clientName, mobileNumber },
        }
      );

      const invoicesData = response.data?.$values || [];
      setInvoices(invoicesData);
      setError(null);
    } catch (error) {
      console.error("Error fetching invoices:", error.response);
      setError(
        error.response?.data?.message || "Error fetching pending invoices"
      );
      setInvoices([]);
    }
    setLoading(false);
  };

  // const handleSearchClick = () => {
  //   setShowTable(true);
  //   fetchPendingInvoices();
  // };                      
  const handleSearchClick = () => {
    const mobileError = validateMobileNumber(mobileNumber);
    const nameError = validateClientName(clientName);

    if (mobileError) {
      setErrors({ ...errors, mobileNumber: mobileError, clientName: nameError });
      return;
    }

    setShowTable(true);
    fetchPendingInvoices();
  };

  // const fetchInvoiceItems = async (invoiceNumber) => {
  //   try {
  //     const response = await axios.get(
  //       // `https://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`
  //       `http://localhost:5045/api/Invoice/${invoiceNumber}`
  //     );
  //     const invoiceData = response.data;

  //     if (invoiceData) {
  //       const totalAmount =
  //         invoiceData.items?.$values?.reduce(
  //           (total, item) => total + item.unitPrice * item.quantity,
  //           0
  //         ) || 0;

  //       const remainingBalance = Math.max(
  //         totalAmount -
  //           (invoiceData.paidAmount + (invoiceData.advanceAmount || 0)),
  //         0
  //       );

  //       setInvoiceNumber(invoiceData.invoiceNumber);
  //       setBaseInvoiceNumber(invoiceData.baseInvoiceNumber);
  //       setClientId(invoiceData.clientId);
  //       setClientName(invoiceData.clientName);
  //       setMobileNumber(invoiceData.mobileNumber);
  //       setTax(invoiceData.tax);
  //       setDiscount(invoiceData.discount);
  //       setPaidAmount(invoiceData.paidAmount);
  //       setAdvanceAmount(invoiceData.advanceAmount);
  //       setInvoiceItems(invoiceData.items?.$values || []);
  //       setRemainingBalance(remainingBalance);
  //       setIsPendingInvoice(true);
  //       setTotalAmount(remainingBalance);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching invoice details:", error);
  //   }
  // };

  // const handleItemChange = (index, field, value) => {
  //   if (field === "quantity") {
  //     const cleanedValue = value.replace(/[^0-9]/g, "");
  //     if (cleanedValue === "" || /^\d+$/.test(cleanedValue)) {
  //       const updatedItems = [...invoiceItems];
  //       updatedItems[index] = {
  //         ...updatedItems[index],
  //         [field]: cleanedValue === "" ? "" : parseInt(cleanedValue) || 0,
  //       };
  //       setInvoiceItems(updatedItems);
  //     }
  //   } else if (field === "unitPrice") {
  //     const cleanedValue = value
  //       .replace(/[^0-9.]/g, "")
  //       .replace(/^\./, "0.")
  //       .replace(/\./, "x")
  //       .replace(/\./g, "")
  //       .replace(/x/, ".");

  //     if (cleanedValue === "" || /^\d*\.?\d*$/.test(cleanedValue)) {
  //       const updatedItems = [...invoiceItems];
  //       updatedItems[index] = {
  //         ...updatedItems[index],
  //         [field]: cleanedValue === "" ? "" : cleanedValue,
  //       };
  //       setInvoiceItems(updatedItems);
  //     }
  //   } else {
  //     const updatedItems = [...invoiceItems];
  //     updatedItems[index] = {
  //       ...updatedItems[index],
  //       [field]: value,
  //     };
  //     setInvoiceItems(updatedItems);
  //   }
  // };
  const fetchInvoiceItems = async (invoiceNumber) => {
    try {
      const response = await axios.get(
        `https://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`
        // `http://localhost:5045/api/Invoice/${invoiceNumber}`
      );
      const invoiceData = response.data;

      if (invoiceData) {
        setInvoiceNumber(invoiceData.invoiceNumber);
        setBaseInvoiceNumber(invoiceData.baseInvoiceNumber);
        setClientId(invoiceData.clientId);
        setClientName(invoiceData.clientName);
        setMobileNumber(invoiceData.mobileNumber);
        setTax(invoiceData.tax);
        setDiscount(invoiceData.discount);
        setPaidAmount(invoiceData.paidAmount);
        setAdvanceAmount(invoiceData.advanceAmount);
        setInvoiceItems(invoiceData.items?.$values || []);
        setRemainingBalance(invoiceData.remainingBalance);
        setIsPendingInvoice(true);
        setTotalAmount(invoiceData.total);
      }
    } catch (error) {
      console.error("Error fetching invoice details:", error);
    }
  };
  const handleItemChange = (index, field, value) => {
    if (field === "quantity") {
      const cleanedValue = value
        .replace(/[^0-9.]/g, "")
        .replace(/^\./, "0.")
        .replace(/\./, "x")
        .replace(/\./g, "")
        .replace(/x/, ".");

      if (cleanedValue === "" || /^\d*\.?\d*$/.test(cleanedValue)) {
        const updatedItems = [...invoiceItems];
        updatedItems[index] = {
          ...updatedItems[index],
          [field]: cleanedValue === "" ? "" : cleanedValue,
        };
        setInvoiceItems(updatedItems);
      }
    } else if (field === "unitPrice") {
      const cleanedValue = value
        .replace(/[^0-9.]/g, "")
        .replace(/^\./, "0.")
        .replace(/\./, "x")
        .replace(/\./g, "")
        .replace(/x/, ".");

      if (cleanedValue === "" || /^\d*\.?\d*$/.test(cleanedValue)) {
        const updatedItems = [...invoiceItems];
        updatedItems[index] = {
          ...updatedItems[index],
          [field]: cleanedValue === "" ? "" : cleanedValue,
        };
        setInvoiceItems(updatedItems);
      }
    } else {
      const updatedItems = [...invoiceItems];
      updatedItems[index] = {
        ...updatedItems[index],
        [field]: value,
      };
      setInvoiceItems(updatedItems);
    }
  };
  const handleAddItem = () => {
    setInvoiceItems([
      ...invoiceItems,
      { productName: "", quantity: "", unitPrice: "" },
    ]);
  };

  const handleRemoveItem = (index) => {
    setInvoiceItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  // const calculateTotal = () => {
  //   if (isPendingInvoice) {
  //     return remainingBalance;
  //   }

  //   if (invoiceItems?.length > 0) {
  //     const totalAmount = invoiceItems.reduce((total, item) => {
  //       const quantity =
  //         typeof item.quantity === "string"
  //           ? parseFloat(item.quantity.replace(/,/g, ""))
  //           : item.quantity;
  //       const unitPrice =
  //         typeof item.unitPrice === "string"
  //           ? parseFloat(item.unitPrice.replace(/,/g, ""))
  //           : item.unitPrice;
  //       return total + unitPrice * quantity;
  //     }, 0);

  //     const totalWithTax = totalAmount + totalAmount * (tax / 100);
  //     const totalWithTaxAndDiscount =
  //       totalWithTax - totalWithTax * (discount / 100);
  //     return totalWithTaxAndDiscount;
  //   }
  //   return 0;
  // };

  const calculateTotal = () => {
    if (isPendingInvoice) {
      return totalAmount;
    }

    if (invoiceItems?.length > 0) {
      const subtotal = invoiceItems.reduce((total, item) => {
        const quantity = parseFormattedNumber(item.quantity);
        const unitPrice = parseFormattedNumber(item.unitPrice);
        return total + unitPrice * quantity;
      }, 0);

      const totalWithTax = subtotal + subtotal * (tax / 100);
      const totalWithTaxAndDiscount =
        totalWithTax - totalWithTax * (discount / 100);
      return totalWithTaxAndDiscount;
    }
    return 0;
  };

  const handlePaidAmountChange = (e) => {
    let value = e.target.value;
    value = value
      .replace(/[^0-9.]/g, "")
      .replace(/^\./, "0.")
      .replace(/\./, "x")
      .replace(/\./g, "")
      .replace(/x/, ".");

    setPaidAmount(value);
  };

  const handleAdvanceAmountChange = (e) => {
    let value = e.target.value;
    value = value
      .replace(/[^0-9.]/g, "")
      .replace(/^\./, "0.")
      .replace(/\./, "x")
      .replace(/\./g, "")
      .replace(/x/, ".");

    setAdvanceAmount(value);
  };

  const handleTaxChange = (e) => {
    let value = e.target.value;
    value = value
      .replace(/[^0-9.]/g, "")
      .replace(/^\./, "0.")
      .replace(/\./, "x")
      .replace(/\./g, "")
      .replace(/x/, ".");

    setTax(parseFloat(value) || 0);
  };

  const handleDiscountChange = (e) => {
    let value = e.target.value;
    value = value
      .replace(/[^0-9.]/g, "")
      .replace(/^\./, "0.")
      .replace(/\./, "x")
      .replace(/\./g, "")
      .replace(/x/, ".");

    setDiscount(parseFloat(value) || 0);
  };

  const calculateDisplayAmount = (quantity, unitPrice) => {
    if (!quantity || !unitPrice) return "0";
    const qty =
      typeof quantity === "string"
        ? parseFloat(quantity.replace(/,/g, ""))
        : quantity;
    const price =
      typeof unitPrice === "string"
        ? parseFloat(unitPrice.replace(/,/g, ""))
        : unitPrice;
    return formatNumber((qty * price).toFixed(2));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   const parsedPaidAmount = parseFormattedNumber(paidAmount);
  //   const parsedAdvanceAmount = parseFormattedNumber(advanceAmount);

  //   if (isAdvancePayment && parsedAdvanceAmount <= 0) {
  //     alert("Advance amount must be filled for advance payment.");
  //     setLoading(false);
  //     return;
  //   }

  //   if (!isAdvancePayment && parsedPaidAmount <= 0) {
  //     alert("Paid amount must be filled if it's not an advance payment.");
  //     setLoading(false);
  //     return;
  //   }

  //   const fullPaymentRequired =
  //     remainingBalance > 0 && parsedPaidAmount !== remainingBalance;
  //   if (fullPaymentRequired) {
  //     alert("The full balance must be paid to settle the invoice.");
  //     setLoading(false);
  //     return;
  //   }

  //   let finalInvoiceNumber = invoiceNumber;
  //   let finalBaseInvoiceNumber = baseInvoiceNumber;
  //   let finalBaseInvoiceNumberId = 0;
  //   let finalAdvanceAmount = isAdvancePayment ? parsedAdvanceAmount : 0;

  //   const existingInvoice = invoices.find(
  //     (inv) => inv.invoiceNumber === invoiceNumber && inv.remainingBalance > 0
  //   );

  //   if (existingInvoice) {
  //     finalInvoiceNumber = existingInvoice.invoiceNumber;
  //     finalBaseInvoiceNumber = existingInvoice.baseInvoiceNumber;
  //     finalBaseInvoiceNumberId = existingInvoice.baseInvoiceNumberId;
  //     finalAdvanceAmount = existingInvoice.advanceAmount;
  //   } else if (!invoiceNumber) {
  //     finalInvoiceNumber = `INV_${Date.now()}`;
  //     setIsPendingInvoice(false);
  //   }

  //   let calculatedTotal;
  //   if (isPendingInvoice) {
  //     calculatedTotal = totalAmount;
  //   } else {
  //     calculatedTotal = invoiceItems.reduce((total, item) => {
  //       const quantity = parseFormattedNumber(item.quantity);
  //       const unitPrice = parseFormattedNumber(item.unitPrice);
  //       return total + unitPrice * quantity;
  //     }, 0);
  //   }

  //   const totalWithTax = calculatedTotal + calculatedTotal * (tax / 100);
  //   const totalWithTaxAndDiscount =
  //     totalWithTax - totalWithTax * (discount / 100);

  //   let newRemainingBalance;
  //   if (isPendingInvoice) {
  //     newRemainingBalance = Math.max(
  //       remainingBalance - (parsedPaidAmount + finalAdvanceAmount),
  //       0
  //     );
  //   } else {
  //     newRemainingBalance = Math.max(
  //       totalWithTaxAndDiscount - (parsedPaidAmount + finalAdvanceAmount),
  //       0
  //     );
  //   }

  //   const invoiceData = {
  //     invoiceNumber: finalInvoiceNumber,
  //     baseInvoiceNumber: finalBaseInvoiceNumber,
  //     baseInvoiceNumberId: finalBaseInvoiceNumberId,
  //     userID: user.userID,
  //     companyID: user.companyID,
  //     total: calculatedTotal,
  //     date: new Date().toISOString(),
  //     clientId: clientId,
  //     clientName: clientName,
  //     mobileNumber: mobileNumber,
  //     tax: tax,
  //     discount: discount,
  //     paidAmount: parsedPaidAmount,
  //     advanceAmount: finalAdvanceAmount,
  //     remainingBalance: newRemainingBalance,
  //     pendingStatus: newRemainingBalance > 0 ? "Pending" : "Completed",
  //     items: invoiceItems.map((item) => ({
  //       invoiceNumber: finalInvoiceNumber,
  //       invoiceNumberId: 0,
  //       productName: item.productName,
  //       unitPrice: parseFormattedNumber(item.unitPrice),
  //       quantity: parseFormattedNumber(item.quantity),
  //     })),
  //   };

  //   try {
  //     const response = await axios.post(
  //       //  "https://invoice.dockyardsoftware.com/api/Invoice",
  //       "http://localhost:5045/api/Invoice",
  //       invoiceData
  //     );
  //     setSubmittedData(invoiceData);
  //     setShowSuccessPopup(true);
  //     alert("Invoice submitted successfully");
  //   } catch (error) {
  //     console.error("Error submitting invoice", error.response);
  //     alert("Failed to submit invoice");
  //   }

  //   setLoading(false);
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const mobileError = validateMobileNumber(mobileNumber);
    const nameError = validateClientName(clientName);

    if (mobileError || nameError) {
      setErrors({ ...errors, mobileNumber: mobileError, clientName: nameError });
      setLoading(false);
      return;
    }

    if (!clientName.trim()) {
      alert("Client name is required");
      setLoading(false);
      return;
    }

    if (invoiceItems.length === 0) {
      alert("Please add at least one item to the invoice");
      setLoading(false);
      return;
    }

    for (let item of invoiceItems) {
      if (!item.productName.trim()) {
        alert("Product name is required for all items");
        setLoading(false);
        return;
      }
      if (!item.quantity || parseFormattedNumber(item.quantity) <= 0) {
        alert("Quantity must be greater than 0 for all items");
        setLoading(false);
        return;
      }
      if (!item.unitPrice || parseFormattedNumber(item.unitPrice) <= 0) {
        alert("Unit price must be greater than 0 for all items");
        setLoading(false);
        return;
      }
    }

    const parsedPaidAmount = parseFormattedNumber(paidAmount);
    const parsedAdvanceAmount = parseFormattedNumber(advanceAmount);

    if (isAdvancePayment && parsedAdvanceAmount <= 0) {
      alert("Advance amount must be filled for advance payment.");
      setLoading(false);
      return;
    }

    if (!isAdvancePayment && parsedPaidAmount <= 0) {
      alert("Paid amount must be filled if it's not an advance payment.");
      setLoading(false);
      return;
    }

    const fullPaymentRequired =
      remainingBalance > 0 && parsedPaidAmount !== remainingBalance;
    if (fullPaymentRequired) {
      alert("The full balance must be paid to settle the invoice.");
      setLoading(false);
      return;
    }

    let finalInvoiceNumber = invoiceNumber;
    let finalBaseInvoiceNumber = baseInvoiceNumber;
    let finalBaseInvoiceNumberId = 0;
    let finalAdvanceAmount = isAdvancePayment ? parsedAdvanceAmount : 0;

    const existingInvoice = invoices.find(
      (inv) => inv.invoiceNumber === invoiceNumber && inv.remainingBalance > 0
    );

    if (existingInvoice) {
      finalInvoiceNumber = existingInvoice.invoiceNumber;
      finalBaseInvoiceNumber = existingInvoice.baseInvoiceNumber;
      finalBaseInvoiceNumberId = existingInvoice.baseInvoiceNumberId;
      finalAdvanceAmount = existingInvoice.advanceAmount;
    } else if (!invoiceNumber) {
      finalInvoiceNumber = `INV_${Date.now()}`;
      setIsPendingInvoice(false);
    }

    let calculatedTotal;
    if (isPendingInvoice) {
      calculatedTotal = totalAmount;
    } else {
      calculatedTotal = invoiceItems.reduce((total, item) => {
        const quantity = parseFormattedNumber(item.quantity);
        const unitPrice = parseFormattedNumber(item.unitPrice);
        return total + unitPrice * quantity;
      }, 0);
    }

    const totalWithTax = calculatedTotal + calculatedTotal * (tax / 100);
    const totalWithTaxAndDiscount =
      totalWithTax - totalWithTax * (discount / 100);

    let newRemainingBalance;
    if (isPendingInvoice) {
      newRemainingBalance = Math.max(
        remainingBalance - (parsedPaidAmount + finalAdvanceAmount),
        0
      );
    } else {
      newRemainingBalance = Math.max(
        totalWithTaxAndDiscount - (parsedPaidAmount + finalAdvanceAmount),
        0
      );
    }

    const invoiceData = {
      invoiceNumber: finalInvoiceNumber,
      baseInvoiceNumber: finalBaseInvoiceNumber,
      baseInvoiceNumberId: finalBaseInvoiceNumberId,
      userID: user.userID,
      companyID: user.companyID,
      total: calculatedTotal,
      date: new Date().toISOString(),
      clientId: clientId,
      clientName: clientName.trim(),
      mobileNumber: mobileNumber,
      tax: tax,
      discount: discount,
      paidAmount: parsedPaidAmount,
      advanceAmount: finalAdvanceAmount,
      remainingBalance: newRemainingBalance,
      pendingStatus: newRemainingBalance > 0 ? "Pending" : "Completed",
      items: invoiceItems.map((item) => ({
        invoiceNumber: finalInvoiceNumber,
        invoiceNumberId: 0,
        productName: item.productName.trim(),
        unitPrice: parseFormattedNumber(item.unitPrice),
        quantity: parseFormattedNumber(item.quantity),
      })),
    };

    try {
      const response = await axios.post(
         "https://invoice.dockyardsoftware.com/api/Invoice",
        // "http://localhost:5045/api/Invoice",
        invoiceData
      );
      setSubmittedData(invoiceData);
      setShowSuccessPopup(true);
      alert("Invoice submitted successfully");
    } catch (error) {
      console.error("Error submitting invoice", error.response);
      alert(
        `Failed to submit invoice: ${
          error.response?.data?.message || error.message
        }`
      );
    }

    setLoading(false);
  };

  const handlePrint = (e) => {
    e.preventDefault();
    if (!submittedData || !submittedData.invoiceNumber) {
      alert("Invoice not submitted yet or missing invoice number.");
      return;
    }
    navigate(`/viewPort/${submittedData.invoiceNumber}`, {
      state: { invoiceData: submittedData },
    });
  };

  const handleClose = () => {
    setShowSuccessPopup(false);
    setTimeout(() => window.location.reload(), 300);
  };

  return (
    <div
      className="flex justify-center items-start px-4 py-4 sm:py-1 overflow-y-auto min-h-screen"
      style={{
        backgroundImage: `url(${formbg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        opacity: 0.9,
      }}
    >
      <div className="w-full max-w-5xl bg-white/80 shadow-lg rounded-2xl p-4 sm:p-6 flex flex-col my-2 sm:my-7">
        <div
          className="relative flex justify-center items-center rounded-xl p-6"
          style={{
            backgroundImage: `url(${flag})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "120px",
          }}
        >
          <div className="bg-white w-[80%] max-w-lg p-4 rounded-xl shadow-md text-center">
            <h2 className="text-m font-bold text-[#24419A]">
              Hi, {user ? user.username : "Guest"}!!
            </h2>
            <p className="text-xs font-bold text-gray-400">
              Current Time: {time}
            </p>
            <p className="text-xs font-bold text-gray-400">
              Current Date: {formatDate(date)}
            </p>
          </div>
        </div>

        <div className="mt-4 grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] gap-4 items-end">
          <div className="w-full">
            <label className="block font-bold text-sm text-[#3C6BFF]">
              Client Name
            </label>
            <input
              type="text"
              value={clientName}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[A-Za-z\s]*$/.test(value)) {
                  setClientName(e.target.value);
                  setErrors({ ...errors, clientName: "" });
                }
              }}
              onBlur={() => {
                const error = validateClientName(clientName);
                setErrors({ ...errors, clientName: error });
              }}
              placeholder="Enter Customer Name..."
              className="w-full border-2 border-blue-500 text-sm h-10 rounded-lg p-2 mt-1"
            />
          </div>

          <div className="w-full relative">
            <label className="block font-bold text-sm text-[#3C6BFF]">
              Client Number
            </label>
            <input
              type="text"
              value={mobileNumber}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  setMobileNumber(value);
                  setErrors({ ...errors, mobileNumber: "" });
                }
              }}
              onBlur={() => {
                const error = validateMobileNumber(mobileNumber);
                setErrors({ ...errors, mobileNumber: error });
              }}
              placeholder="Enter Customer Number..."
              className={`w-full border-2 ${
                errors.mobileNumber ? "border-red-500" : "border-blue-500"
              } text-sm h-10 rounded-lg p-2 mt-1`}
            />
            <div className="absolute">
              {errors.mobileNumber && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.mobileNumber}
                </p>
              )}
            </div>
          </div>

          <div className="flex">
            <button
              onClick={handleSearchClick}
              className="bg-blue-600 text-white px-4 py-2 h-10 rounded-lg hover:bg-blue-700 transition w-auto"
            >
              {loading ? "Searching..." : "Search"}
            </button>
          </div>
        </div>

        {showTable && (
          <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-4/5 max-w-6xl">
              <div className="flex justify-between">
                <h3 className="text-xl font-bold">Invoices</h3>
                <button
                  onClick={() => setShowTable(false)}
                  className="text-red-500 font-bold"
                >
                  X
                </button>
              </div>
              <div className="overflow-x-auto mt-4">
                {/* <table className="w-full text-sm text-left text-gray-500 border table-auto">
                  <thead className="text-xs text-white uppercase bg-blue-600">
                    <tr>
                      <th className="px-4 py-3">Invoice Number</th>
                      <th className="px-4 py-3">Base Invoice Number</th>
                      <th className="px-4 py-3">Client Name</th>
                      <th className="px-4 py-3">Total</th>
                      <th className="px-4 py-3">Date</th>
                      <th className="px-4 py-3">Paid</th>
                      <th className="px-4 py-3">Advance</th>
                      <th className="px-4 py-3">Remaining Balance</th>
                      <th className="px-4 py-3">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td
                          colSpan="9"
                          className="text-center py-3 text-gray-500"
                        >
                          Loading invoices...
                        </td>
                      </tr>
                    ) : invoices.length > 0 ? (
                      invoices.map((invoice) => (
                        <tr key={invoice.invoiceNumber} className="border">
                          <td className="px-4 py-2">{invoice.invoiceNumber}</td>
                          <td className="px-4 py-2">
                            {invoice.baseInvoiceNumber}
                          </td>
                          <td className="px-4 py-2">{invoice.clientName}</td>
                          <td className="px-4 py-2">
                            {formatNumber(invoice.total)}
                          </td>
                          <td className="px-4 py-2">{invoice.date}</td>
                          <td className="px-4 py-2">
                            {formatNumber(invoice.paidAmount)}
                          </td>
                          <td className="px-4 py-2">
                            {formatNumber(invoice.advanceAmount)}
                          </td>
                          <td className="px-4 py-2">
                            {formatNumber(invoice.remainingBalance)}
                          </td>
                          <td className="px-4 py-2">
                            {invoice.pendingStatus === "Pending" ? (
                              <button
                                className="text-blue-500"
                                onClick={() => {
                                  fetchInvoiceItems(invoice.invoiceNumber);
                                  setShowTable(false);
                                }}
                              >
                                Pending
                              </button>
                            ) : (
                              "Completed"
                            )}
                          </td>
                        </tr>u
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="9"
                          className="text-center py-3 text-gray-500"
                        >
                          No invoices found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table> */}

                <table className="w-full text-sm text-left text-black border-2 border-white mt-2">
                  <thead className="text-xs text-white uppercase bg-blue-600">
                    <tr>
                      <th className="px-4 py-2">Invoice Number</th>
                      <th className="px-4 py-2">Base Invoice Number</th>
                      <th className="px-4 py-2">Client Name</th>
                      <th className="px-4 py-2">Total</th>
                      <th className="px-4 py-2">Date</th>
                      <th className="px-4 py-2">Paid</th>
                      <th className="px-4 py-2">Advance</th>
                      <th className="px-4 py-2">Remaining Balance</th>
                      <th className="px-4 py-2 text-center">Pending</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td
                          colSpan="9"
                          className="text-center py-3 text-gray-500"
                        >
                          Loading invoices...
                        </td>
                      </tr>
                    ) : invoices.length > 0 ? (
                      invoices.map((invoice) => (
                        <tr
                          key={invoice.invoiceNumber}
                          className="border-b-2 border-white"
                        >
                          <td className="px-4 py-2">{invoice.invoiceNumber}</td>
                          <td className="px-4 py-2">
                            {invoice.baseInvoiceNumber}
                          </td>
                          <td className="px-4 py-2">{invoice.clientName}</td>
                          <td className="px-4 py-2 text-right">
                            {formatNumber(invoice.total)}
                          </td>
                          <td className="px-4 py-2">{invoice.date}</td>
                          <td className="px-4 py-2 text-right">
                            {formatNumber(invoice.paidAmount)}
                          </td>
                          <td className="px-4 py-2 text-right">
                            {formatNumber(invoice.advanceAmount)}
                          </td>
                          <td className="px-4 py-2 text-right">
                            {formatNumber(invoice.remainingBalance)}
                          </td>
                          <td className="px-4 py-2 text-center">
                            {invoice.pendingStatus === "Pending" ? (
                              <button
                                className="text-blue-500 hover:text-blue-700"
                                onClick={() => {
                                  fetchInvoiceItems(invoice.invoiceNumber);
                                  setShowTable(false);
                                }}
                              >
                                Pending
                              </button>
                            ) : (
                              "Completed"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="9"
                          className="text-center py-3 text-gray-500"
                        >
                          No invoices found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        <div className="flex-grow overflow-auto mt-4 pb-4">
          <h3 className="text-xl font-semibold">Invoice Items</h3>
          <table className="w-full text-sm text-left text-black border-2 border-white mt-2">
            <thead className="text-xs text-white uppercase bg-blue-600">
              <tr>
                <th className="px-4 py-2">Product Name</th>
                <th className="px-4 py-2">Qty</th>
                <th className="px-4 py-2">Price</th>
                <th className="px-4 py-2">Amount</th>
                <th className="px-4 py-2 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {invoiceItems.length > 0 ? (
                invoiceItems.map((item, index) => (
                  <tr key={index} className="border-b-2 border-white">
                    <td className="px-4 py-2">
                      <input
                        value={item.productName}
                        onChange={(e) =>
                          handleItemChange(index, "productName", e.target.value)
                        }
                        type="text"
                        className="border p-1 rounded w-full"
                        placeholder="Product"
                      />
                    </td>
                    <td className="px-4 py-2">
                      <input
                        value={formatNumber(item.quantity)}
                        onChange={(e) =>
                          handleItemChange(index, "quantity", e.target.value)
                        }
                        type="text"
                        className="border p-1 rounded w-full text-left"
                        placeholder="Qty"
                      />
                    </td>
                    <td className="px-4 py-2">
                      <input
                        value={formatNumber(item.unitPrice)}
                        onChange={(e) =>
                          handleItemChange(index, "unitPrice", e.target.value)
                        }
                        type="text"
                        className="border p-1 rounded w-full text-left"
                        placeholder="Price"
                      />
                    </td>
                    <td className="px-4 py-2 text-right">
                      {calculateDisplayAmount(item.quantity, item.unitPrice)}
                    </td>
                    <td className="px-4 py-2 text-center flex items-center justify-center gap-3">
                      <button
                        onClick={() => handleRemoveItem(index)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <Trash size={20} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-3 text-gray-500">
                    No items added yet.
                  </td>
                </tr>
              )}

              <tr className="border">
                <td colSpan="5" className="text-center py-3">
                  <button
                    onClick={handleAddItem}
                    className="text-blue-500 hover:text-blue-700 flex items-center justify-center gap-2"
                  >
                    <Plus size={20} />
                    Add Item
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* <div className="w-full mt-2 p-4 border rounded bg-white/50 text-sm h-[250px] overflow-y-auto">
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={isAdvancePayment}
              onChange={(e) => setIsAdvancePayment(e.target.checked)}
            />
            <label className="text-sm font-bold text-gray-700">
              Advance Payment
            </label>
          </div>

          <div className="flex space-x-2 mb-2">
            <div className="w-1/2">
              <label>Tax (%)</label>
              <input
                type="text"
                value={formatNumber(tax)}
                onChange={handleTaxChange}
                className="border p-1 rounded w-full text-left"
                placeholder="0"
              />
            </div>
            <div className="w-1/2">
              <label>Discount (%)</label>
              <input
                type="text"
                value={formatNumber(discount)}
                onChange={handleDiscountChange}
                className="border p-1 rounded w-full text-left"
                placeholder="0"
              />
            </div>
          </div>

          <div className="w-1/2">
            <label>Paid Amount:</label>
            <input
              value={formatNumber(paidAmount)}
              onChange={handlePaidAmountChange}
              onBlur={(e) => {
                const value = parseFormattedNumber(e.target.value) || 0;
                setPaidAmount(value);
              }}
              type="text"
              className="border p-1 rounded w-full text-left"
              placeholder="Enter Paid Amount..."
            />
          </div>

          {isAdvancePayment && (
            <div className="w-1/2">
              <label>Advance Amount</label>
              <input
                value={formatNumber(advanceAmount)}
                onChange={handleAdvanceAmountChange}
                onBlur={(e) => {
                  const value = parseFormattedNumber(e.target.value) || 0;
                  setAdvanceAmount(value);
                }}
                type="text"
                className="border p-1 rounded w-full text-left"
                placeholder="Enter Advance Amount"
              />
            </div>
          )}

          
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="w-full">
              <label className="block font-bold text-sm text-[#3C6BFF]">
                {isPendingInvoice ? "Original Total" : "Total"}
              </label>
              <input
                type="text"
                value={formatNumber(calculateTotal())}
                readOnly
                className="w-full border-2 border-blue-500 text-sm h-10 rounded-lg p-2 mt-1 bg-gray-200 text-left"
              />
            </div>
            {isPendingInvoice && (
              <div className="w-full">
                <label className="block font-bold text-sm text-[#3C6BFF]">
                  Remaining Balance
                </label>
                <input
                  type="text"
                  value={formatNumber(remainingBalance)}
                  readOnly
                  className="w-full border-2 border-blue-500 text-sm h-10 rounded-lg p-2 mt-1 bg-gray-200 text-left"
                />
              </div>
            )}
            <div>
              <button
                className="bg-blue-500 text-white px-3 py-1 rounded mt-7"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div> */}

        {/*when user ticked Advance Payment then the Paid Amount: filed will be hide, without this option old code is above*/}
        <div className="w-full mt-2 p-4 border rounded bg-white/50 text-sm h-[250px] overflow-y-auto">
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={isAdvancePayment}
              onChange={(e) => setIsAdvancePayment(e.target.checked)}
            />
            <label className="text-sm font-bold text-gray-700">
              Advance Payment
            </label>
          </div>

          <div className="flex space-x-2 mb-2">
            <div className="w-1/2">
              <label>Tax (%)</label>
              <input
                type="text"
                value={formatNumber(tax)}
                onChange={handleTaxChange}
                className="border p-1 rounded w-full text-left"
                placeholder="0"
              />
            </div>
            <div className="w-1/2">
              <label>Discount (%)</label>
              <input
                type="text"
                value={formatNumber(discount)}
                onChange={handleDiscountChange}
                className="border p-1 rounded w-full text-left"
                placeholder="0"
              />
            </div>
          </div>

          {!isAdvancePayment && (
            <div className="w-1/2">
              <label>Paid Amount:</label>
              <input
                value={formatNumber(paidAmount)}
                onChange={handlePaidAmountChange}
                onBlur={(e) => {
                  const value = parseFormattedNumber(e.target.value) || 0;
                  setPaidAmount(value);
                }}
                type="text"
                className="border p-1 rounded w-full text-left"
                placeholder="Enter Paid Amount..."
              />
            </div>
          )}

          {isAdvancePayment && (
            <div className="w-1/2">
              <label>Advance Amount</label>
              <input
                value={formatNumber(advanceAmount)}
                onChange={handleAdvanceAmountChange}
                onBlur={(e) => {
                  const value = parseFormattedNumber(e.target.value) || 0;
                  setAdvanceAmount(value);
                }}
                type="text"
                className="border p-1 rounded w-full text-left"
                placeholder="Enter Advance Amount"
              />
            </div>
          )}

          <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="w-full">
              <label className="block font-bold text-sm text-[#3C6BFF]">
                {isPendingInvoice ? "Original Total" : "Total"}
              </label>
              <input
                type="text"
                value={formatNumber(calculateTotal())}
                readOnly
                className="w-full border-2 border-blue-500 text-sm h-10 rounded-lg p-2 mt-1 bg-gray-200 text-left"
              />
            </div>
            {isPendingInvoice && (
              <div className="w-full">
                <label className="block font-bold text-sm text-[#3C6BFF]">
                  Remaining Balance
                </label>
                <input
                  type="text"
                  value={formatNumber(remainingBalance)}
                  readOnly
                  className="w-full border-2 border-blue-500 text-sm h-10 rounded-lg p-2 mt-1 bg-gray-200 text-left"
                />
              </div>
            )}
            <div>
              <button
                className="bg-blue-500 text-white px-3 py-1 rounded mt-7"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        {showSuccessPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-2xl shadow-xl max-w-md w-full">
              <div className="flex flex-col items-center">
                <svg
                  className="w-12 h-12 text-green-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M2.25 12a9.75 9.75 0 1117.72 6.28l2.26 2.26a.75.75 0 11-1.06 1.06l-2.26-2.26A9.75 9.75 0 112.25 12zm14.78-2.97a.75.75 0 00-1.06-1.06l-4.97 4.97-2.47-2.47a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l5.5-5.5z"
                    clipRule="evenodd"
                  />
                </svg>
                <h2 className="text-lg font-semibold text-green-600 mt-3">
                  Invoice Submitted
                </h2>
                <p className="text-gray-600 text-center mt-1">
                  Invoice{" "}
                  <span className="font-medium text-gray-900">
                    {submittedData.invoiceNumber}
                  </span>{" "}
                  has been successfully processed.
                </p>
              </div>

              <div className="mt-4 bg-gray-100 p-4 rounded-lg shadow-inner">
                <h3 className="text-gray-700 font-semibold text-sm">
                  Invoice Details
                </h3>
                <div className="mt-2 text-sm text-gray-600 space-y-1">
                  <p>
                    <span className="font-medium">Client:</span>{" "}
                    {submittedData.clientName}
                  </p>
                  <p>
                    <span className="font-medium">Mobile:</span>{" "}
                    {submittedData.mobileNumber}
                  </p>
                  <p>
                    <span className="font-medium">Date:</span>{" "}
                    {new Date(submittedData.date).toLocaleDateString()}
                  </p>
                  <p>
                    <span className="font-medium">Total:</span> Rs.
                    {formatNumber(submittedData.total)}
                  </p>
                  <p>
                    <span className="font-medium">Paid:</span> Rs.
                    {formatNumber(submittedData.paidAmount)}
                  </p>
                  <p>
                    <span className="font-medium">Remaining Balance:</span> Rs.
                    {formatNumber(submittedData.remainingBalance)}
                  </p>
                  <p>
                    <span className="font-medium">Status:</span>{" "}
                    <span
                      className={`font-medium px-2 py-1 rounded ${
                        submittedData.pendingStatus === "Pending"
                          ? "bg-yellow-100 text-yellow-800"
                          : "bg-green-100 text-green-800"
                      }`}
                    >
                      {submittedData.pendingStatus}
                    </span>
                  </p>
                </div>
              </div>

              <div className="mt-4">
                <h3 className="text-gray-700 font-semibold text-sm">
                  Items Purchased
                </h3>
                <div className="mt-2 bg-gray-50 p-3 rounded-lg shadow-inner">
                  <table className="w-full text-sm text-gray-700">
                    <thead>
                      <tr className="border-b">
                        <th className="text-left p-1">Product</th>
                        <th className="text-right p-1">Unit Price</th>
                        <th className="text-right p-1">Qty</th>
                        <th className="text-right p-1">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {submittedData.items.map((item, index) => (
                        <tr key={index} className="border-b">
                          <td className="p-1">{item.productName}</td>
                          <td className="text-right p-1">
                            Rs.{formatNumber(item.unitPrice)}
                          </td>
                          <td className="text-right p-1">
                            {formatNumber(item.quantity)}
                          </td>
                          <td className="text-right p-1">
                            Rs.{formatNumber(item.unitPrice * item.quantity)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <button
                onClick={handleClose}
                className="mt-4 w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Close
              </button>

              <button
                className="mt-4 w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
                onClick={handlePrint}
              >
                Print
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoicePage;
